export default __webpack_public_path__ + "static/media/webix.99dfb57f.svg";